import { Link } from 'react-router-dom';
import '../navigation/NavOptions.scss';

function NavItem({ name, to = undefined, child = undefined, selected = '' }) {

    return (
        <div className={"option" + (selected === name ? ' selected' : '')}>
            {
                to ? <Link  reloadDocument={true} to={to}>{name}</Link> : <div>{name}</div>
            }
            {child && child}
        </div>
    );
};
export default NavItem;